import { useMemo } from "react";

export const useFormatMenuItem = (label?: string) => {
    const formatMenuItem = useMemo(() => {
        if (!label) {
            return "";
        }
        return label.toLowerCase().replace(/\s+/g, "_");
    }, [label]);

    return formatMenuItem;
};
